"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuspenseConditionCodesRestrictedFromOverrides = exports.SuspenseConditionCode = void 0;
var SuspenseConditionCode;
(function (SuspenseConditionCode) {
    SuspenseConditionCode["CompleteClaimReceivedDateIsBlank"] = "10";
    SuspenseConditionCode["DeprecatedCompleteClaimReceivedDateIsBlank"] = "CL1029";
    SuspenseConditionCode["SupplementaryClaimReceivedLessThan$250"] = "02";
    SuspenseConditionCode["SupplementaryClaimsDocsNotReceivedTitleJudgmentOrBankrupt"] = "04";
    SuspenseConditionCode["AmortizationOfLoanExceeds40Years"] = "05";
    SuspenseConditionCode["RFFICheckFound"] = "11";
    SuspenseConditionCode["GVSPVIIIndicatorFound"] = "17";
    SuspenseConditionCode["ITMNotApproved"] = "22";
    SuspenseConditionCode["EDDFEMSIIndicatorFound"] = "35";
    SuspenseConditionCode["NumberOfChargesClaimedExceedsSystemLimit"] = "98";
    SuspenseConditionCode["OtherBorrowerCharges"] = "12";
    SuspenseConditionCode["OutstandingPrincipalBalance"] = "29";
    SuspenseConditionCode["PropertyDamagedInsuranceSettlementInvolved"] = "34";
    SuspenseConditionCode["MultipleReasons"] = "99";
    SuspenseConditionCode["NoApprovedAmountBorrowerCharges"] = "08";
    SuspenseConditionCode["AdmissibleDateNeedsReview"] = "07";
    SuspenseConditionCode["FlaggedForManualReview"] = "27";
})(SuspenseConditionCode = exports.SuspenseConditionCode || (exports.SuspenseConditionCode = {}));
exports.SuspenseConditionCodesRestrictedFromOverrides = [
    SuspenseConditionCode.ITMNotApproved,
    SuspenseConditionCode.NumberOfChargesClaimedExceedsSystemLimit,
];
